import { countBy, keys, pickBy } from 'lodash';

// NOTE: dont use "chain" in this function so that we can import it into UI
export function getDuplicates(collection: string[]): string[] {
  const occurrences = countBy(collection, element => element);
  const duplicatedOccurrences = pickBy(occurrences, count => count > 1);
  const duplicatedValues = keys(duplicatedOccurrences);
  return duplicatedValues;
}
